import { useContext } from "react";
import { AuthContext } from "../Context/auth";

export const ACESSOS_ADMIN_AUXILIAR = [
  { id: "propostaComercial", nome: "Proposta comercial", rota: "/app/proposta-comercial" },
  { id: "locacaoEquipamentos", nome: "Locação de equipamentos", rota: "/app/locacao-equipamentos" },
  { id: "medicoes", nome: "Medições", rota: "/app/medicoes" },
  { id: "visitaTecnica", nome: "Relatórios de visita técnica", rota: "/app/relatorios-visita-tecnica" },
  { id: "logoRelatorios", nome: "Logo do sistema e relatórios", rota: "/app/configuracoes/logo-relatorios" },
  { id: "tabelaCilindros", nome: "Tabela de cilindros", rota: "/app/configuracoes/tabela-cilindros" },
  { id: "tabelaCapsulas", nome: "Tabela de cápsulas", rota: "/app/configuracoes/tabela-capsulas" },
  { id: "faixasDnit", nome: "Faixas DNIT - Solos", rota: "/app/configuracoes/faixas-dnit" },
  { id: "faixasDnitAsfalto", nome: "Faixas DNIT - Asfalto CBUQ", rota: "/app/configuracoes/faixas-dnit-asfalto" },
];

export function usePermissoesAcesso() {
  const { permissoesAcesso = {} } = useContext(AuthContext);
  const tipo = String(localStorage.getItem("tipoUsuario") || "").toLowerCase();
  const adminPrincipal = tipo === "admin" && localStorage.getItem("adminPrincipal") === "S";
  const podeAcessarRota = (rota = "") => {
    if (tipo !== "admin") return false;
    if (adminPrincipal) return true;
    const acesso = ACESSOS_ADMIN_AUXILIAR.find((item) =>
      rota === item.rota || rota.startsWith(`${item.rota}/`)
    );
    return Boolean(acesso && permissoesAcesso[acesso.id] === true);
  };
  const podeAcessarItem = (item) => item.path
    ? podeAcessarRota(item.path)
    : (item.children || []).some(podeAcessarItem);
  return {
    adminPrincipal,
    podeAcessarRota,
    podeAcessarItem,
    podeEditarDosagem: tipo === "admin" || (tipo === "colaborador" && permissoesAcesso.dosagemEditar === true),
  };
}
